import type { WithActiveBranchId } from '@app/api/shared';

export enum UserFileRequestsEndpoints {
  TestFileRequestClients = 'TestFileRequestClients',
  StartFileRequestClients = 'StartFileRequestClients',
  GetFileRequestInfo = 'GetFileRequestInfo',
  DownloadFileRequest = 'DownloadFileRequest',
  TestFileRequestRecords = 'TestFileRequestRecords',
  StartFileRequestRecords = 'StartFileRequestRecords',
}

export interface ModelTestFileRequest {
  CanPrepare: boolean;
  ErrorMessage?: string | null;
  Email?: string | null;
  LifetimeHours: number;
  Warning?: string | null;
}

export interface ModelRequestFileInfo {
  SecretId?: string | null;
  Subject?: string | null;
  CreateTime: string;
  UserId: number;
  UserName?: string | null;
  BranchName?: string | null;
  DownloadCount: number;
  FileName?: string | null;
  CanDownload: boolean;
  FileLifetime: string;
  FileSize: number;
}

export interface ModelFile {
  Id: number;
  Name?: string | null;
  Data?: string | null;
  Lifetime?: string | null;
  Description?: string | null;
}

export type TestFileRequestClientsRequest = WithActiveBranchId<{
  searchId: number;
}>;

export type StartFileRequestClientsRequest = WithActiveBranchId<{
  searchId: number;
  subject: string;
}>;

export type GetFileRequestInfoRequest = WithActiveBranchId<{
  secretId: string;
}>;

export type DownloadFileRequestRequest = WithActiveBranchId<{
  secretId: string;
}>;

export type TestFileRequestRecordsRequest = WithActiveBranchId<{
  searchId: number;
}>;

export type StartFileRequestRecordsRequest = WithActiveBranchId<{
  searchId: number;
  subject: string;
  groupServices: boolean;
}>;

export type TestFileRequestClientsResponse = ModelTestFileRequest;
export type StartFileRequestClientsResponse = ModelTestFileRequest;
export type GetFileRequestInfoResponse = ModelRequestFileInfo;
export type DownloadFileRequestResponse = ModelFile;
export type TestFileRequestRecordsResponse = ModelTestFileRequest;
export type StartFileRequestRecordsResponse = ModelTestFileRequest;
